<template>
  <div>
    <v-app-bar
      dense
      flat
      height="50"
    >
      <v-row align="center">
        <v-col
          xs="12"
          sm="5"
          md="4"
          class="d-none d-sm-flex"
        >
          <search-field
            :search-text="searchText"
            :status="status"
            @statusChange="changeStatus"
            @search="onSearch"
          />            
        </v-col>
        <v-col
          xs="12"
          sm="7"
          md="8"
          align="end"
        >
          <v-btn
            id="store_refresh"
            color="primary"
            :loading="loader"
            class="mr-1 elevation-0"
            @click.native="reload()"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <v-btn
            id="new_store"
            class="elevation-0"
            color="success"
            disabled
            @click="newStore()"
          >
            <v-icon>mdi-plus</v-icon> Store
          </v-btn>
        </v-col>
      </v-row>
    </v-app-bar>
    <v-divider />
    <v-card
      flat
      tile
    >
      <v-card-text>
        <v-row>
          <v-col
            xs="12"
            class="d-flex d-sm-none"
          >
            <search-field
              :search-text="searchText"
              :status="status"
              @statusChange="changeStatus"
              @search="onSearch"
            />            
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-divider></v-divider>
        </v-row> -->
        <v-row>
          <v-col
            v-for="store in stores"
            :key="store.id"
            cols="12"
            sm="4"
            md="3"
            xl="2"
            class="d-flex"
          >
            <v-card
              class="mx-auto"
              flat
              outlined
            >
              <v-card-text
                style="cursor:pointer"
                @click="viewStore(store)"
              >
                <v-row
                  class="text-center"
                  no-gutters
                >
                  <v-col
                    cols="12"
                    class="text-h5"
                  >
                    {{ store.name }}
                    <v-icon
                      x-small
                      :color="store.live ? 'success' : 'warning'"
                    >
                      mdi-circle
                    </v-icon>
                  </v-col>
                  <!-- <v-col cols="12">
                    <h4>Email: {{ store.emailId }}</h4>
                    <h4>Phone: {{ store.phoneNumber }}</h4>
                  </v-col> -->
                </v-row>
              </v-card-text>

              <v-divider class="mt-2 mx-4" />

              <v-card-actions>
                <v-row justify="center">
                  <v-col cols="auto">
                    <v-chip
                      v-if="store.activeStatus"
                      outlined
                      label
                      color="success--text"
                    >
                      Active
                    </v-chip>
                    <v-chip
                      v-else
                      outlined
                      label
                      color="error--text"
                    >
                      In-active
                    </v-chip>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions v-show="totalPage > 1">
        <v-row>
          <v-col>
            <v-pagination
              v-model="page"
              :length="totalPage"
              @input="getStores()"
            />
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { failure, pagination } from "@/mixins/common";
import SearchField from "@/components/utils/SearchField";

export default {
	components: {
    SearchField
  },
	mixins: [failure, pagination],
	data() {
		return {
			loader: false,
			stores: [],
      sortKey: "name",
      searchKey: "name",
			searchText: null,
			page: 1,
			totalPage: 0,
      status: ""
		};
	},
	created() {
		this.init();
	},
	methods: {
		getStores() {
			this.loader = true;
			this.stores = [];
			let accountId = this.$route.params.accountId;
			let url = `${this.ADMIN_API_URL}/accounts/${accountId}/stores?page=${this.page - 1}&search_key=${this.searchKey}&sort_key=${this.sortKey}&limit=${this.limit}&status=${this.status}`;
			if (this.searchText) {
				url += `&search=${this.searchText}`;
			}
			this.$http.get(url).then(
				function(res) {
					this.stores = res.body.data || [];
					this.totalPage = res.body.totalPage;
					this.page = res.body.pagination.page + 1;
					this.loader = false;
				},
				function(failure) {
					this.handleFailure(failure);
				}
			);
		},
		search() {
			this.page = 1;
			this.getStores();
		},
		reload() {
			this.searchText = null;
      this.status = "";
			this.search();
		},
    onSearch(val) {
      this.searchText = val;
			if (!val || val.length >= 3) {
        this.search();
      }
    },
		changeStatus(status) {
			this.status = status;
			this.search();
		},
		viewStore(store) {
			this.$router.push({
				name: "storeInfo",
				params: {
					accountId: this.$route.params.accountId,
					storeId: store.id
				}
			});
		},
		init: function() {
			this.getStores();
			this.$store.commit("setTitle", "Account Details");
		}
	}
};
</script>

<style>
.store-tile {
  min-height: 150px;
}
</style>
